module.exports = __webpack_public_path__ + "img/tree-05-h-trunk.1a9a8168.png";